<template>
  <div>
    <Card>
      <Form ref="formInline" :model="searchForm" inline>
        <FormItem prop="accountId" label="Account ID" :label-width="100">
          <Select v-model="searchForm.accountId" placeholder="Account ID" @on-change="getDetail">
            <Option v-for="option in accountOptions" :key="option.value" :value="option.value">{{ option.label }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="dateRange">
          <DatePicker v-model="searchForm.dateRange" :clearable="false" type="daterange" placement="bottom-end" placeholder="Select date" @on-change="getDetail"></DatePicker>
        </FormItem>
      </Form>
    </Card>

    <Card>
      <Spin v-if="totalLoading" fix></Spin>
      <Row class="total-item-wrapper">
        <i-col :span="6">
          <div class="total-item">
            <p class="label">Revenue</p>
            <p class="value">{{ total.revenue }}</p>
          </div>
        </i-col>
        <i-col :span="6">
          <div class="total-item">
            <p class="label">Click</p>
            <p class="value">{{ total.click | symbolNumber(0, ',') }}</p>
          </div>
        </i-col>
        <i-col :span="6">
          <div class="total-item">
            <p class="label">Conversion</p>
            <p class="value">{{ total.conversion }}</p>
          </div>
        </i-col>
        <i-col :span="6">
          <div class="total-item">
            <p class="label">CR</p>
            <p class="value">{{ total.cr }}</p>
          </div>
        </i-col>
      </Row>
    </Card>

    <Card>
      <Spin v-if="lineLoading" fix></Spin>
      <v-chart ref="lineChart" :options="lineOptions"></v-chart>
    </Card>

    <Row :gutter="20" style="margin-top: 20px;">
      <i-col :span="12">
        <Card>
          <Spin v-if="barLoading" fix></Spin>
          <v-chart ref="barChart" :options="barOptions"></v-chart>
        </Card>
      </i-col>
      <i-col :span="12">
        <Card>
          <Spin v-if="pieLoading" fix></Spin>
          <v-chart ref="pieChart" :options="pieOptions"></v-chart>
        </Card>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { Card, Form, FormItem, Select, Option, DatePicker, Row, Col, Spin } from 'view-design'
import ECharts from 'vue-echarts'
import echarts from 'echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { getPublisherList, getTotalRevenue, getDayRevenue, getPkgRevenue, getCountryRevenue } from '@/server'
import moment from 'moment'

export default {
  name: '',
  components: {
    Card,
    Form,
    FormItem,
    Select,
    Option,
    DatePicker,
    Row,
    'i-col': Col,
    'v-chart': ECharts,
    Spin
  },
  data () {
    return {
      accountOptions: [],
      totalLoading: false,
      lineLoading: false,
      barLoading: false,
      pieLoading: false,
      total: {
        revenue: '...',
        conversion: '...',
        click: '...',
        cr: '...'
      },
      searchForm: {
        accountId: '',
        dateRange: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')]
      },
      lineOptions: {
        color: ['#7D9DFF', '#FF8623'],
        title: {
          text: 'Performance',
          top: 8
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: '#9EA7B3'
            }
          }
        },
        legend: {
          data: ['Conversion', 'Revenue'],
          top: 30,
          itemGap: 66,
          textStyle: {
            color: '#899199'
          }
        },
        grid: {
          top: 80,
          left: 30,
          right: 30,
          bottom: 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#E8EFF1'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#9EA7B3',
            margin: 20
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#9EA7B3',
            margin: 20
          },
          splitLine: {
            lineStyle: {
              color: '#E8EFF1'
            }
          }
        },
        series: [
          {
            name: 'Conversion',
            type: 'line',
            symbolSize: 8
          },
          {
            name: 'Revenue',
            type: 'line',
            symbolSize: 8
          }
        ]
      },
      barOptions: {
        color: ['#42CB93'],
        title: {
          text: 'Top Offer',
          top: 8
        },
        tooltip: {
          axisPointer: {
            lineStyle: {
              color: '#9EA7B3'
            }
          }
        },
        grid: {
          top: 50,
          left: 10,
          right: 30,
          bottom: 20,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          boundaryGap: true,
          data: [],
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#b2b2b2',
            margin: 16
          }
        },
        xAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#E8EFF1'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#9EA7B3',
            margin: 20,
            showMaxLabel: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: 'offer',
            type: 'bar',
            barWidth: 18
          }
        ]
      },
      pieOptions: {
        color: ['#FFE387', '#F9B57E', '#FF956C', '#FF7711 ', '#F94C46', '#E50C2E', '#FF8BB0', '#F17B7B', '#F20074', '#C90046'],
        title: {
          text: 'Top Geo',
          top: 8
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Geo',
            type: 'pie',
            label: {
              position: 'outer',
              alignTo: 'none',
              bleedMargin: 5,
              color: '#000000'
            },
            labelLine: {
              smooth: true
            },
            itemStyle: {
              normal: {
                borderWidth: 1,
                borderColor: '#fff',
                opacity: 0.85
              }
            }
          }
        ]
      }
    }
  },
  filters: {
    symbolNumber: (num, precision, separator) => {
      var parts
      // 判断是否为数字
      if (!isNaN(parseFloat(num)) && isFinite(num)) {
        num = Number(num)
        num = (typeof precision !== 'undefined'
          ? parseFloat(num, precision)
          : num
        ).toString()
        // 分离数字的小数部分和整数部分
        parts = num.split('.')
        parts[0] = parts[0]
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ''))
        return parts.join('.')
      }
      return '...'
    }
  },
  computed: {
    requestData () {
      return {
        publisherId: this.searchForm.accountId,
        startDay: moment(this.searchForm.dateRange[0]).format('YYYY-MM-DD'),
        endDay: moment(this.searchForm.dateRange[1]).format('YYYY-MM-DD')
      }
    }
  },
  created () {
    this.initData()
    console.log(new echarts.graphic.LinearGradient)
  },
  methods: {
    async initData () {
      await this.getPublisherList()
      if (this.accountOptions.length > 0) { // 默认需要填一个account
        this.searchForm.accountId = this.accountOptions[0].value
        this.getDetail()
      }
    },
    getDetail () {
      this.getTotalRevenue()
      this.getDayRevenue()
      this.getPkgRevenue()
      this.getCountryRevenue()
    },
    async getCountryRevenue () { // Top Geo
      this.pieLoading = true
      const { data } = await getCountryRevenue(this.requestData)
      if (data.code === 200) {
        this.pieOptions.series[0].data = data.data.map(obj => ({
          name: obj.country,
          value: obj.revenue
        }))
        this.$refs.pieChart.clear()
        this.$refs.pieChart.mergeOptions(this.pieOptions)
      }
      this.pieLoading = false
    },
    async getPkgRevenue () { // top offer
      this.barLoading = true
      const { data } = await getPkgRevenue(this.requestData)
      if (data.code === 200) {
        this.barOptions.series[0].data = data.data.map((obj, index) => {
          return {
            value: obj.revenue,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: index % 2 === 0 ? '#FF8623' : '#ffdabd'
              }, {
                offset: 1,
                color: index % 2 === 0 ? '#F20075' : '#fbb2d5'
              }]),
              }
            }
          }
        })
        this.barOptions.series[0].data.reverse()
        this.barOptions.yAxis.data = data.data.map(obj => obj.pkg)
        this.barOptions.yAxis.data.reverse()
        this.$refs.barChart.clear()
        this.$refs.barChart.mergeOptions(this.barOptions)
      }
      this.barLoading = false
    },
    async getDayRevenue () { // 每日数据，折线图
      this.lineLoading = true
      const { data } = await getDayRevenue(this.requestData)
      if (data.code === 200) {
        this.lineOptions.xAxis.data = data.data.map(obj => obj.date)
        this.lineOptions.series[0].data = data.data.map(obj => obj.conversion)
        this.lineOptions.series[1].data = data.data.map(obj => obj.revenue)
        this.$refs.lineChart.clear()
        this.$refs.lineChart.mergeOptions(this.lineOptions)
      }
      this.lineLoading = false
    },
    async getPublisherList () { // account列表
      const { data } = await getPublisherList()
      if (data.code === 200) {
        this.accountOptions = data.data.nicknames.map(obj => ({
          label: obj.nickname,
          value: obj.publisherId
        }))
      }
    },
    async getTotalRevenue () { // 总数
      this.totalLoading = true
      const { data } = await getTotalRevenue(this.requestData)
      if (data.code === 200) {
        this.total = {
          ...data.data,
          revenue: '$' + data.data.revenue
        }
      }
      this.totalLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
  .echarts {
    width: 100%;
    height: 500px;
  }
  .ivu-card + .ivu-card {
    margin-top: 20px;
  }
  .ivu-form {
    text-align: right;
  }
  .ivu-form-item {
    text-align: left;
    margin-bottom: 0;
    .ivu-select, .ivu-date-picker {
      width: 309px;
    }
  }
  .ivu-form-inline {
    .ivu-form-item {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .total-item-wrapper {
    .total-item {
      text-align: center;
      margin: 16px 0;
      line-height: 1;
      border-right: 1px solid #f0f0f0;
      .label {
        font-size: 12px;
        color: #666;
        font-family: PingFang-SC-Bold, PingFang-SC;
        margin-bottom: 8px;
      }
      .value {
        font-size: 28px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #000;
      }
    }
    .ivu-col:last-child .total-item {
      border-right: none;
    }
  }
</style>
